const IMPERSONATION_ADMIN_TOKEN = "impersonation_admin_token";

export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  const parts = token.trim().split(".");
  if (parts.length !== 3) return null;
  try {
    const json = atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function isUsableJwt(token) {
  if (!token || token.split(".").length !== 3) return false;
  const payload = decodeJwtPayload(token);
  if (!payload) return false;
  if (payload.exp && Number(payload.exp) * 1000 < Date.now() - 5000) return false;
  return true;
}

/** Prefer admin JWT when impersonating a client or when backup admin token exists. */
export function getAdminAuthToken() {
  const token = String(localStorage.getItem("authToken") || "").trim();
  const adminBackup = String(sessionStorage.getItem(IMPERSONATION_ADMIN_TOKEN) || "").trim();
  const payload = decodeJwtPayload(token);

  if (payload?.isImpersonation && isUsableJwt(adminBackup)) return adminBackup;
  if (Number(payload?.role) === 1 && isUsableJwt(token)) return token;
  if (isUsableJwt(adminBackup) && Number(decodeJwtPayload(adminBackup)?.role) === 1) {
    return adminBackup;
  }
  if (isUsableJwt(token)) return token;
  if (isUsableJwt(adminBackup)) return adminBackup;
  return "";
}

export function getAuthToken() {
  return String(localStorage.getItem("authToken") || "").trim();
}

export function buildAuthHeaders({ admin = false } = {}) {
  const token = admin ? getAdminAuthToken() : getAuthToken();
  if (!isUsableJwt(token)) return {};
  return { Authorization: `Bearer ${token}` };
}
